import React from 'react';
import { Button } from 'antd';
import { INVOICE_STATUS } from 'constants/salesforceInvoices';
import { DownloadOutlined } from '@ant-design/icons';
import { getTranslationKeyByInvoiceStatus } from './helper';

import styles from './style.module.scss';

const InvoiceStatusCell = ({ status, translateText }) => {
  const translationKey = getTranslationKeyByInvoiceStatus(status);

  return (
    <div className={`${styles.tag} ${styles[status]}`}>
      <span>{translateText(translationKey)}</span>
    </div>
  );
};

const tableColumns = ({ handleInvoiceDownload, translateText }) => [
  {
    title: translateText('corporateAccounts.invoices.document'),
    key: 'documentType',
    width: 180,
    render: (_text, record) => {
      return record.documentType === 'Invoice' ? (
        <div>{translateText('corporateAccounts.invoices.invoice')}</div>
      ) : (
        <div>{record.documentType}</div>
      );
    },
  },
  {
    title: translateText('corporateAccounts.invoices.invoiceNumber'),
    dataIndex: 'invoiceNumber',
    width: 180,
  },
  {
    title: translateText('corporateAccounts.common.date'),
    dataIndex: 'invoiceDate',
    width: 180,
  },
  {
    title: translateText('corporateAccounts.common.status'),
    dataIndex: 'invoiceStatus',
    key: 'invoiceStatus',
    width: 180,
    filters: Object.values(INVOICE_STATUS).map(status => {
      const translationKey = getTranslationKeyByInvoiceStatus(status);
      return {
        text: translateText(translationKey),
        value: status,
      };
    }),
    onFilter: (value, record) => {
      return record.invoiceStatus === value;
    },
    render: status => {
      return <InvoiceStatusCell status={status} translateText={translateText} />;
    },
  },
  {
    title: translateText('corporateAccounts.invoicesAndStatements.totalAmount'),
    dataIndex: 'totalAmount',
    width: 180,
  },
  {
    title: translateText('corporateAccounts.invoices.outstandingAmount'),
    dataIndex: 'outstandingAmount',
    width: 180,
  },
  {
    title: translateText('corporateAccounts.invoicesAndStatements.downloadInvoice'),
    key: 'downloadinvoice',
    width: 180,
    render: (_text, record) => {
      return (
        <div>
          <Button
            className={styles.downloadButton}
            onClick={() => {
              handleInvoiceDownload({ invoiceId: record.invoiceId });
            }}
            data-testid="downloadInvoiceTableButton"
          >
            {translateText('corporateAccounts.actions.download')}
            <span className={styles.downloadIcon}>
              <DownloadOutlined />
            </span>
          </Button>
        </div>
      );
    },
  },
];

export default tableColumns;
